import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpStatusCode } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "@core/auth";
import { LoggingService } from "@core/logging";
import { catchError, EMPTY, Observable, throwError } from "rxjs";

export function errorResponseInterceptor(
	req: HttpRequest<unknown>,
	next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
	const authService = inject(AuthService);
	const loggingService = inject(LoggingService);

	return next(req).pipe(
		catchError((err: HttpErrorResponse) => {
			loggingService.logException(err);

			if (err.status === HttpStatusCode.Unauthorized) {
				authService.redirectUserToLogin();
				return EMPTY;
			}

			return throwError(() => err);
		})
	);
}
